import React from 'react';
import classNames from 'classnames';
import { ErrorMessage } from 'formik';

import Input from './Input';
import useInputs from '../../../hooks/useInputs';
import { formStyles } from '../../../lib/constants/SiteVariables';

export default function StickyInput(props) {
  const { id, placeholder } = props;
  const {
    errorComponent: ErrorComponent,
    helperText,
    onSuggestionClick,
    ...inputProps
  } = props;

  if (!id || !placeholder) throw new Error('Missing required props');

  const { multi, hasFieldError, hasColumnError, fieldErrMsg, fieldComplete } =
    useInputs(inputProps);

  const describedBy = helperText
    ? `${id}-helper-text`
    : inputProps['aria-describedby'];
  const columnErrorAffectsLabel = hasColumnError && !helperText;

  const inputField = (
    <>
      <Input
        {...inputProps}
        aria-describedby={describedBy}
      />
      <label
        htmlFor={id}
        className={classNames(
          'absolute text-xs sm:text-sm transition-all duration-300 origin-left left-3.5 top-1/2 transform -translate-y-1/2 peer-focus:-translate-y-4 sm:peer-focus:-translate-y-5 peer-focus:text-primary-blue peer-focus:scale-75 peer-focus:left-3.5',
          { 'top-[35%] -translate-y-[35%]': columnErrorAffectsLabel },
          {
            '!top-[45%] sm:!top-[35%]':
              !hasFieldError && columnErrorAffectsLabel,
          },
          fieldComplete
            ? 'text-tertiary-gray scale-75 -translate-y-4 sm:-translate-y-5 peer-focus:left-3.5'
            : 'text-secondary-gray'
        )}
      >
        {placeholder}
      </label>
    </>
  );

  const validationMessage =
    multi && hasColumnError ? (
      <div
        className={classNames(
          'sm:h-5',
          formStyles.validation,
          hasFieldError ? 'my-0.5 sm:h-auto' : 'h-0'
        )}
      >
        {hasFieldError && fieldErrMsg}
      </div>
    ) : ErrorComponent ? (
      <ErrorComponent
        fieldId={id}
        hasFieldError={hasFieldError}
        onSuggestionClick={onSuggestionClick}
      />
    ) : (
      <ErrorMessage
        name={id}
        component="div"
        className={classNames(
          'sm:h-5',
          formStyles.validation,
          hasFieldError ? 'my-0.5 h-4' : 'h-0'
        )}
      />
    );

  if (helperText) {
    return (
      <div className="flex flex-col items-start outline-none">
        <div className="form-floating flex flex-col items-start relative outline-none w-full">
          {inputField}
        </div>
        <div
          id={`${id}-helper-text`}
          className="text-left text-xxs sm:text-xs text-secondary-gray mt-1"
        >
          {helperText}
        </div>
        {validationMessage}
      </div>
    );
  }

  return (
    <div className="form-floating flex flex-col items-start relative outline-none">
      {inputField}
      {validationMessage}
    </div>
  );
}
